export default class XRayTestRepository {
  static [Symbol.hasInstance](obj: any) {
    if (obj.Name && obj.Path && obj.URL) return true;
  }

  public Name = "";
}
